module.exports = __webpack_public_path__ + "img/roomimg.c99cd9fa.jpg";